export function isTimeSignature(x) {
    return typeof x?.numerator == 'number' && typeof x?.denominator == 'number';
}
export function getTickNote(signature) {
    return signature.tickNote ?? signature.denominator;
}
export function getTicksPerMeasure(signature) {
    return signature.numerator * getTickNote(signature) / signature.denominator;
}
//# sourceMappingURL=TimeSignature.js.map